import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-600ae49a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox-styled" }
const _hoisted_2 = ["id", "name", "disabled", "aria-labelledby", "value", "data-t-cb-input"]
const _hoisted_3 = ["for"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "input text-left"
}
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        class: "checkbox-styled__input",
        type: "checkbox",
        id: _ctx.id,
        name: _ctx.name,
        ref: _ctx.name + _ctx.id,
        disabled: _ctx.disabled,
        "aria-labelledby": _ctx.labelledby,
        value: _ctx.inputValue,
        "data-t-cb-input": _ctx.testProp,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.change) = $event)),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changed()))
      }, null, 40, _hoisted_2), [
        [_vModelCheckbox, _ctx.change]
      ]),
      (_ctx.$slots.default)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: "checkbox-styled__label",
            for: _ctx.id,
            tabindex: "0",
            onKeyup: [
              _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.changeItem()), ["enter"])),
              _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.changeItem()), ["space"]))
            ]
          }, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ], 40, _hoisted_3))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "checkbox-styled__label",
            tabindex: "0",
            onKeyup: [
              _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.changeItem()), ["enter"])),
              _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.changeItem()), ["space"]))
            ]
          }, null, 32)),
      _hoisted_4
    ]),
    (_ctx.showError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", {
            class: "input__field--error_message input__field--error_message--selects",
            innerHTML: _ctx.validationErrorText
          }, null, 8, _hoisted_6)
        ]))
      : _createCommentVNode("", true)
  ]))
}